import { Component } from "react";
import Headerdash from "../components/headerdash";

export default class C extends Component {
    constructor() {
        super();
        this.state = {
            coursedetails: []
        };
    }

    updatelist = (value, i) => {
        let cpy = this.state.coursedetails;
        cpy[i] = value;
        this.setState({coursedetails: cpy});
    }

    addrow = () => {
        let cr = [...this.state.coursedetails];
        cr.push('');
        this.setState({
            coursedetails: cr
        });
    }

    removerow = (i) => {
        let cr = [...this.state.coursedetails];
        cr.splice(i, 1);
        this.setState({
            coursedetails: cr
        });
    }

    componentDidMount() {
        fetch('https://api.voicecoach.net/courselist')
        .then(res => res.json())
        .then(r => {console.log(r); this.setState({coursedetails: r})});
    }

    savecourselist = () => {
        fetch('https://api.voicecoach.net/updatecourselist', {method: 'POST', headers: {'Content-type':'application/json'},
    body: JSON.stringify(this.state.coursedetails), credentials: 'include'},)
    .then(res => { if (res.statusText === 'OK') { alert('Saved'); window.open('/course-details')}})
    }

    render() {
        let cdx = this.state.coursedetails.map((cd, i) => <div className="my-1 row">
            <div key={i} className="form-group col-11">
            <input type="text" className="form-control" onChange={evt => this.updatelist(evt.target.value, i)} value={cd} />
            </div>
            <div className="col-1 btn btn-danger" onClick={() => this.removerow(i)}>X</div></div>);
        return <>
        <Headerdash />
        <div className="container">
            <div className="row">
                <div className="col-lg-6 mx-auto col-12">
                    <h3 className="mt-5 mb-3">Key Features:</h3>
        {cdx}
        </div>
        <div className="row">
            <div className="col-lg-6 mx-auto col-12 position-relative">
                <div className="row mb-3">
                    <div className="col-2 mt-2">
                    <button className="roundbutton btn btn-primary" onClick={this.addrow}>+ add</button>
                    </div>
                </div>
                <button className="mt-3 btn btn-primary btn-lg end-0 position-absolute" onClick={this.savecourselist}>Done? Click this to save</button>
            </div>
        </div>
            </div>
        </div>
        </>
    }
}